import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../index.css';
import '../styles/PersonasPage.css';
import { useAuth } from '../authentication/AuthContext';

function OurPersonas() {
  const { user } = useAuth();
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const personas = [
    {
      name: "Emily",
      title: "Marketing Manager",
      age: 34,
      salary: "€85,000/year",
      image: require('../components/personas/Emily.jpg'),
      interests: ["Digital Marketing", "Yoga", "Travel Photography"],
      backstory: "With 8 years of experience in digital marketing, Emily leads campaigns for major retail brands. She's passionate about data-driven decision making and building authentic brand voices.",
      challenges: "Balancing creative innovation with ROI metrics",
      goals: ["Increase brand engagement by 25%", "Develop sustainable marketing strategies"]
    },
    {
      name: "James",
      title: "Retired School Principal",
      age: 67,
      salary: "€32,000/year (pension)",
      image: require('../components/personas/James.jpg'),
      interests: ["Gardening", "Volunteering", "Classical Music"],
      backstory: "James spent over 40 years in education, shaping the lives of thousands of students. Now retired, he volunteers at local literacy programs and enjoys spending time with his grandchildren.",
      challenges: "Staying active and engaged in the community",
      goals: ["Mentor young educators", "Travel to historical sites"]
    },
    {
      name: "Sophie",
      title: "Freelance Graphic Designer",
      age: 23,
      salary: "€28,000/year",
      image: require('../components/personas/Sophie.jpg'),
      interests: ["Illustration", "Street Art", "Indie Music"],
      backstory: "Sophie is a recent art school graduate building her freelance portfolio. She works with startups and local businesses to create unique visual identities.",
      challenges: "Finding steady clients and managing finances",
      goals: ["Land a major brand project", "Host her first solo art show"]
    },
    {
      name: "Thomas",
      title: "Factory Shift Supervisor",
      age: 51,
      salary: "€48,000/year",
      image: require('../components/personas/Thomas.jpg'),
      interests: ["Fishing", "DIY Projects", "Football"],
      backstory: "Thomas has worked in manufacturing for over 25 years, rising from line worker to supervisor. He values teamwork and safety on the job.",
      challenges: "Adapting to new automation technologies",
      goals: ["Improve team safety record", "Save for early retirement"]
    },
    {
      name: "Sarah",
      title: "University Student",
      age: 19,
      salary: "€6,000/year (part-time)",
      image: require('../components/personas/Sarah.jpg'),
      interests: ["Environmental Activism", "Photography", "Travel"],
      backstory: "Sarah is studying environmental science and works part-time at a café. She's passionate about sustainability and hopes to work for an NGO.",
      challenges: "Balancing studies, work, and activism",
      goals: ["Win a research grant", "Organize a campus sustainability event"]
    },
    {
      name: "Daniel",
      title: "Paramedic",
      age: 41,
      salary: "€39,000/year",
      image: require('../components/personas/Daniel.jpg'),
      interests: ["Mountain Biking", "Cooking", "First Aid Training"],
      backstory: "Daniel has been a paramedic for 15 years, responding to emergencies in both urban and rural areas. He also teaches first aid courses.",
      challenges: "Managing stress and long shifts",
      goals: ["Train more community members in first aid", "Complete a marathon"]
    },
    {
      name: "Laura",
      title: "Entrepreneur (Bakery Owner)",
      age: 29,
      salary: "€54,000/year",
      image: require('../components/personas/Laura.jpg'),
      interests: ["Baking", "Local Markets", "Yoga"],
      backstory: "Laura opened her own bakery after years as a pastry chef. She's focused on organic, locally sourced ingredients and community engagement.",
      challenges: "Competing with large chains",
      goals: ["Open a second location", "Develop a line of gluten-free products"]
    },
    {
      name: "Abdel",
      title: "Taxi Driver",
      age: 58,
      salary: "€31,000/year",
      image: require('../components/personas/Abdel.jpg'),
      interests: ["Chess", "World News", "Family Gatherings"],
      backstory: "Abdel immigrated 20 years ago and has been driving a taxi ever since. He enjoys meeting new people and sharing stories from his home country.",
      challenges: "Navigating city changes and ride-share competition",
      goals: ["Buy a new car", "Visit his hometown with his children"]
    },
    {
      name: "Ryan",
      title: "High School Student",
      age: 16,
      salary: "€1,200/year (odd jobs)",
      image: require('../components/personas/Ryan.jpg'),
      interests: ["Video Games", "Skateboarding", "Robotics Club"],
      backstory: "Ryan is a tech-savvy teenager who loves building robots and dreams of becoming an engineer. He does odd jobs for neighbors to save for college.",
      challenges: "Balancing schoolwork and hobbies",
      goals: ["Win a robotics competition", "Get a scholarship for university"]
    }
  ];

  return (
    <div className="personas-page">
      <div className="intro-text">
        <h2>Meet our Personas</h2>
        <div className="container">
          <p>These digital participants instantly provide detailed responses tailored specifically to your unique research use-cases, delivering precise, actionable insights.</p>
          <p>As our community grows, each persona becomes more detailed and nuanced, learning from thousands of interactions to provide increasingly valuable feedback.</p>
        </div>
      </div>
      <div className="personas-grid">
        {personas.map((persona, index) => (
          <div
            className="persona-card"
            key={index}
            onClick={() => toggleCard(index)}
          >
            <img
              src={persona.image}
              alt={`${persona.name}`}
              className="persona-image"
            />
            <h3>{persona.name}</h3>
            <h4>{persona.title}</h4>
            <div className="persona-details">
              <p><strong>Age:</strong> {persona.age}</p>
              <p><strong>Salary:</strong> {persona.salary}</p>
            </div>
          </div>
        ))}
      </div>

      <div className={`expanded-overlay ${expandedCard !== null ? 'active' : ''}`}>
        {expandedCard !== null && (
          <div className="expanded-card" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-button"
              onClick={(e) => {
                e.stopPropagation();
                setExpandedCard(null);
              }}
            >
              ×
            </button>
            <div className="container" style={{ textAlign: 'center' }}>
            <img
              src={personas[expandedCard].image}
              alt={`${personas[expandedCard].name}`}
              className="persona-image"
            />
            <h3>{personas[expandedCard].name}</h3>
            <h4>{personas[expandedCard].title}</h4>
            <div className="persona-details">
              <p><strong>Age:</strong> {personas[expandedCard].age}</p>
              <p><strong>Salary:</strong> {personas[expandedCard].salary}</p>
            </div>
            </div>

            <div className="persona-expanded">
              <h4>Interests</h4>
              <ul>
                {personas[expandedCard].interests.map((interest, i) => (
                  <li key={i}>{interest}</li>
                ))}
              </ul>
              <h4>Background</h4>
              <p>{personas[expandedCard].backstory}</p>
              <h4>Key Challenges</h4>
              <p>{personas[expandedCard].challenges}</p>
              <h4>Goals</h4>
              <ul>
                {personas[expandedCard].goals.map((goal, i) => (
                  <li key={i}>{goal}</li>
                ))}
              </ul>
            </div>
            </div>
        )}
      </div>

      <div className="hero hero-3">
        <div className="outro-text">
          <h3>Unlock Rapid Consumer Insights</h3>
          <div className="container">
            <p>Our personas enable companies to quickly generate targeted insights specifically aligned to practical research use cases helping guide strategic decisions, validate assumptions, and test ideas with exceptional speed and accuracy. </p>
            <p>Whether you're testing new concepts, exploring market opportunities, or validating assumptions, our growing persona community is ready to provide valuable feedback within minutes.</p>
          </div>
        </div>

        {user ? (
              <Link to="/research" className="standout-button button">Start research</Link>
            ) : (
              <Link 
                to="/login" 
                state={{
                  from: '/research',
                  message: 'Please log in to access the app and start your research'
                }}
                className="standout-button button"
              >
                Try it for free! &rarr;
              </Link>
            )}
      </div>
    </div>
  );
}

export default OurPersonas;
